import { Box, Flex, Text } from "@chakra-ui/react";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import { useEffect, useState } from "react";
import AvisosService from "../../../../main/services/AvisosService";
import ListItemAvisos from "../../../components/ListItemAvisos";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthProvider } from "../../../../Context/AuthProvider";

export default function DashboardAvisos() {
  const [listAvisos, setListAvisos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const [printingId, setPrintingId] = useState(null);
  const { selectedProfile, selectedOrgao } = useAuthProvider();

  useEffect(() => {
    let ignore = false;
    AvisosService.getAvisos()
      .then((res) => {
        if (ignore) return;
        setListAvisos(res.data);

        const itemComData = res?.data?.find(
          (item) => item?.dataUltimaAtualizacao
        );

        if (itemComData?.dataUltimaAtualizacao) {
          const data = new Date(itemComData?.dataUltimaAtualizacao);
          const dia = String(data?.getDate()).padStart(2, "0");
          const mes = String(data?.getMonth() + 1)?.padStart(2, "0");
          const ano = data?.getFullYear();
          const hora = String(data?.getHours())?.padStart(2, "0");
          setUltimaAtualizacao(`${dia}/${mes}/${ano} ${hora}h`);
        }
      })
      .catch(() => {
        if (!ignore) setListAvisos([]);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [selectedProfile, selectedOrgao]);

  return (
    <Flex
      pt={"20px"}
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Group title={"Avisos"} opcoes={true} voltar={true}>
        {ultimaAtualizacao && (
          <Flex mt={6} alignItems="center" gap={2}>
            <Box
              w="3"
              h="3"
              bg="#169499"
              borderRadius="full"
              border="1px"
              color="#169499"
            />
            <Text>Última atualização: {ultimaAtualizacao}</Text>
          </Flex>
        )}
        <Flex flexDir="column" mt={6}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              {listAvisos?.length > 0 &&
                listAvisos.map((avisos, index) => (
                  <Box key={avisos?.idTipoAviso}>
                    <ListItemAvisos
                      index={avisos?.idTipoAviso}
                      avisos={avisos}
                      isPrinting={isPrinting}
                      printingId={printingId}
                      setIsPrinting={setIsPrinting}
                      setPrintingId={setPrintingId}
                    />
                  </Box>
                ))}
            </>
          )}
        </Flex>
      </Group>
    </Flex>
  );
}
